var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { ByRevisedEstimateCreateUrl, RepairTypeList, RevisedEstimateCreateUrlBajaj, RevisedEstimateIsExistUrl, RevisedEstimateUpsertJobUrl, getSavedAdditionalJobsUrl, getUnitOfMeasurementListUrl, jobCardGetDetailAPI } from '../../../api/url';
import { ArrowLeftIconNew } from '../../../assets/images';
import { MuiBorderBottom, MuiStack } from '../../../components';
import { MuiIconButton } from '../../../components/atoms/iconButtonComponent';
import { MuiLoaderButton } from '../../../components/atoms/loaderButton';
import { EParentModuleName, ESystemName, LOCAL_STORAGE_KEYS, Module, isModuleConfig } from '../../../constants';
import { showLoader } from '../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, resetState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import useAnalyticsEventTracker from '../../../utils/useAnalyticsEventTracker';
import AdditionalJobsComponent from '../../commonViews/taskDetails/taskDetailsCommonComponent/additionalJob/additionalJobComponent';
import { systemColor } from '../../../theme/systemColor';
import { getLocalStorageItem } from '../../../utils/storageHelper';
var AddNewJobsBajaj = function () {
    var _a = useSelector(function (state) { return state.crud; }), RevisedEstimateIsExist = _a.RevisedEstimateIsExist, upsertAdditionalItem = _a.upsertAdditionalItem;
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var _b = useParams(), id = _b.id, preJobCardDocumentId = _b.preJobCardDocumentId;
    var _c = useState(true), IsbtnDisabled = _c[0], setIsbtnDisabled = _c[1];
    var _d = useState(true), IsSavebtnDisabled = _d[0], setIsSavebtnDisabled = _d[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _e = useState({
        saveButtonStatus: false,
        generateButtonStatus: false,
        RevisedEstimateId: ''
    }), sendData = _e[0], setSendData = _e[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _f = useState({
        "Additional Jobs": false,
        "Customer Voice": false,
        "Periodic Maintenance": false,
        "Standard Services": false
    }), alternatePartConfigState = _f[0], setAlternatePartConfigState = _f[1];
    var trackButtonClick = useAnalyticsEventTracker("AddNewJobsBajaj");
    useEffect(function () {
        getDocumentDetails();
        if (!preJobCardDocumentId || !(RevisedEstimateIsExist !== null && RevisedEstimateIsExist !== void 0 && RevisedEstimateIsExist.data)) {
            checkRevisedEstimateAPICall();
        }
    }, []);
    var getServiceTypesList = function (ProductId) { return __awaiter(void 0, void 0, void 0, function () {
        var _repairType$payload, _repairType$payload2, request, repairType, _repairType$payload3, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    request = {
                        ModuleEntityId: ESystemName.Estimate,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    if (ProductId) {
                        request.ProductId = ProductId;
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "serviceTypeList",
                            url: RepairTypeList,
                            request: request
                        }))];
                case 1:
                    repairType = _a.sent();
                    if ((repairType === null || repairType === void 0 || (_repairType$payload = repairType.payload) === null || _repairType$payload === void 0 || (_repairType$payload = _repairType$payload.value) === null || _repairType$payload === void 0 ? void 0 : _repairType$payload.statusCode) == 200 || repairType !== null && repairType !== void 0 && (_repairType$payload2 = repairType.payload) !== null && _repairType$payload2 !== void 0 && (_repairType$payload2 = _repairType$payload2.value) !== null && _repairType$payload2 !== void 0 && _repairType$payload2.success) {
                        return [2 /*return*/, repairType === null || repairType === void 0 || (_repairType$payload3 = repairType.payload) === null || _repairType$payload3 === void 0 || (_repairType$payload3 = _repairType$payload3.value) === null || _repairType$payload3 === void 0 ? void 0 : _repairType$payload3.data];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error("Error fetching repair types:", e_1);
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getUOMList = function (ProductId) { return __awaiter(void 0, void 0, void 0, function () {
        var request, UOMList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        ModuleEntityId: ESystemName.Estimate,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    if (ProductId) {
                        request.ProductId = ProductId;
                    }
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "UOMList",
                            url: getUnitOfMeasurementListUrl
                        }))];
                case 1:
                    UOMList = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var checkRevisedEstimateAPICall = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestParams, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    requestParams = {
                        ParentId: id
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'RevisedEstimateIsExist',
                            url: RevisedEstimateIsExistUrl,
                            request: requestParams
                        }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUpsertData = function () {
        if (preJobCardDocumentId && sendData.generateButtonStatus) {
            createByRevisedEstimate(sendData.RevisedEstimateId);
        }
        else if (!preJobCardDocumentId && sendData.generateButtonStatus && sendData.RevisedEstimateId) {
            createByRevisedEstimate(sendData.RevisedEstimateId);
        }
    };
    var createByRevisedEstimate = function (payloadRevisedEstimateId) { return __awaiter(void 0, void 0, void 0, function () {
        var _Response$payload, _Response$payload2, _Response$payload3, requestBody, Response, _Response$payload4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        JobCardId: id,
                        RevisedEstimateId: payloadRevisedEstimateId
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: ByRevisedEstimateCreateUrl,
                            request: requestBody
                        }))];
                case 1:
                    Response = _a.sent();
                    if ((Response === null || Response === void 0 || (_Response$payload = Response.payload) === null || _Response$payload === void 0 ? void 0 : _Response$payload.statusCode) == 201 && Response !== null && Response !== void 0 && (_Response$payload2 = Response.payload) !== null && _Response$payload2 !== void 0 && _Response$payload2.success && Response !== null && Response !== void 0 && (_Response$payload3 = Response.payload) !== null && _Response$payload3 !== void 0 && (_Response$payload3 = _Response$payload3.data) !== null && _Response$payload3 !== void 0 && _Response$payload3.PreJobCardDocumentId) {
                        // buttonClickSpan.end();
                        // pageLoadSpan.end();
                        // transaction.end();
                        dispatch(resetState(["documentDetailsGetById"]));
                        navigate("/reviseEstimate-details/RevisedEstimate/".concat(Response === null || Response === void 0 || (_Response$payload4 = Response.payload) === null || _Response$payload4 === void 0 || (_Response$payload4 = _Response$payload4.data) === null || _Response$payload4 === void 0 ? void 0 : _Response$payload4.PreJobCardDocumentId, "/").concat(id), {
                            state: {
                                fromRoute: window.location.pathname
                            }
                        });
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDataFromChild = function (data) {
        setIsbtnDisabled(data);
    };
    var handleButtonStatus = function (data) {
        setIsSavebtnDisabled(data);
    };
    var handleHeaderBackClick = function () {
        navigate("/jobcard-details/".concat(id));
    };
    var getDocumentDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, result, _result$payload2, _result$payload3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'ModuleDetailsGetById',
                            url: jobCardGetDetailAPI(id),
                            request: {}
                        }))];
                case 1:
                    result = _a.sent();
                    console.log("result", result);
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success) {
                        getServiceTypesList(result === null || result === void 0 || (_result$payload2 = result.payload) === null || _result$payload2 === void 0 || (_result$payload2 = _result$payload2.value) === null || _result$payload2 === void 0 || (_result$payload2 = _result$payload2.data) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.ProductId);
                        getUOMList(result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.data) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.ProductId);
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var CreateRevisedEstimate = function (buttonName) { return __awaiter(void 0, void 0, void 0, function () {
        var _createRevisedEstimat, _createRevisedEstimat2, requestBody, createRevisedEstimateResponse, _createRevisedEstimat3, _createRevisedEstimat4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        JobCardId: id
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: RevisedEstimateCreateUrlBajaj,
                            request: requestBody
                        }))];
                case 1:
                    createRevisedEstimateResponse = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (createRevisedEstimateResponse !== null && createRevisedEstimateResponse !== void 0 && (_createRevisedEstimat = createRevisedEstimateResponse.payload) !== null && _createRevisedEstimat !== void 0 && _createRevisedEstimat.success && createRevisedEstimateResponse !== null && createRevisedEstimateResponse !== void 0 && (_createRevisedEstimat2 = createRevisedEstimateResponse.payload) !== null && _createRevisedEstimat2 !== void 0 && (_createRevisedEstimat2 = _createRevisedEstimat2.data) !== null && _createRevisedEstimat2 !== void 0 && _createRevisedEstimat2.PreJobCardDocumentId) {
                        setSendData({
                            saveButtonStatus: true,
                            RevisedEstimateId: createRevisedEstimateResponse === null || createRevisedEstimateResponse === void 0 || (_createRevisedEstimat3 = createRevisedEstimateResponse.payload) === null || _createRevisedEstimat3 === void 0 || (_createRevisedEstimat3 = _createRevisedEstimat3.data) === null || _createRevisedEstimat3 === void 0 ? void 0 : _createRevisedEstimat3.PreJobCardDocumentId,
                            generateButtonStatus: buttonName === "GenerateEstimate" ? true : false
                        });
                        return [2 /*return*/, {
                                RevisedEstimateId: createRevisedEstimateResponse === null || createRevisedEstimateResponse === void 0 || (_createRevisedEstimat4 = createRevisedEstimateResponse.payload) === null || _createRevisedEstimat4 === void 0 || (_createRevisedEstimat4 = _createRevisedEstimat4.data) === null || _createRevisedEstimat4 === void 0 ? void 0 : _createRevisedEstimat4.PreJobCardDocumentId
                            }];
                    }
                    else {
                        return [2 /*return*/, ""];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var RevisedGenerateEstimateFun = function () { return __awaiter(void 0, void 0, void 0, function () {
        var createdRevisedEstimateId, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    createdRevisedEstimateId = "";
                    if (!(preJobCardDocumentId && !sendData.saveButtonStatus)) return [3 /*break*/, 1];
                    // save and go back and then generate estimate
                    setSendData({
                        saveButtonStatus: true,
                        RevisedEstimateId: preJobCardDocumentId,
                        generateButtonStatus: true
                    });
                    return [3 /*break*/, 4];
                case 1:
                    if (!(!preJobCardDocumentId && !sendData.RevisedEstimateId)) return [3 /*break*/, 3];
                    return [4 /*yield*/, CreateRevisedEstimate("GenerateEstimate")];
                case 2:
                    result = _a.sent();
                    if (result.RevisedEstimateId) {
                        createdRevisedEstimateId = result.RevisedEstimateId;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    if (sendData.RevisedEstimateId) {
                        // save and generate estimate
                        createByRevisedEstimate(sendData.RevisedEstimateId);
                    }
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleGenerateEstimate = function () {
        trackButtonClick("ButtonClickEvent", "Genrate_Estimate_Click", undefined);
        RevisedGenerateEstimateFun();
    };
    var handleClicksave = function () {
        trackButtonClick("ButtonClickEvent", "SaveAs_Draft", undefined);
        if (preJobCardDocumentId) {
            setSendData({
                RevisedEstimateId: preJobCardDocumentId,
                saveButtonStatus: true,
                generateButtonStatus: false
            });
        }
        else {
            CreateRevisedEstimate("Save");
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        padding: 2,
        spacing: 2,
        bgcolor: '#f4f7fa'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "backArrowButton",
        onClick: handleHeaderBackClick
    }, /*#__PURE__*/ React.createElement("img", {
        src: ArrowLeftIconNew,
        id: "backArrowIcon"
    })), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1"
    }, t("Add jobs")))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiBorderBottom, null)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 8,
        lg: 6,
        paddingBottom: 10
    }, /*#__PURE__*/ React.createElement(AdditionalJobsComponent, {
        parentModuleName: EParentModuleName.RevisedServiceEstimate,
        getSavedAddiionalJobUrl: getSavedAdditionalJobsUrl,
        saveAdditionalJobsUrl: RevisedEstimateUpsertJobUrl,
        isSaveButton: false,
        isFromRevisedEstimate: true,
        sendDataToChild: sendData,
        getDataFromChild: handleDataFromChild,
        SaveBtnStatus: handleButtonStatus,
        onUpsertData: handleUpsertData,
        alternatePartConfigState: alternatePartConfigState,
        SystemName: ESystemName.RevisedServiceEstimate
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        position: 'fixed',
        bottom: 0,
        right: 0,
        width: '100%',
        spacing: 1,
        paddingBottom: 2,
        bgcolor: systemColor.white
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiBorderBottom, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        paddingRight: 2,
        direction: 'row',
        spacing: 2,
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        id: "save-btn",
        loading: loader.isLoaderOpen,
        variant: "outlined",
        name: t('Save as draft'),
        size: "medium",
        onClick: handleClicksave,
        disabled: IsSavebtnDisabled
    }), /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        id: "generate-estimate-btn",
        loading: loader.isLoaderOpen,
        variant: "contained",
        name: Module === isModuleConfig.Bajaj ? t('Next') : t('Generate estimate'),
        size: "medium",
        onClick: handleGenerateEstimate,
        disabled: IsbtnDisabled
    }))))));
};
export default AddNewJobsBajaj;
